export const minutesToHm = (min: number) => {

    const h = Math.floor(min / 60);
    const m = Math.floor(min % 60);

    return `${h}u ${m}m`;
};
